export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "What areas does B&S Services KC serve?",
    a: "We're headquartered in Olathe, KS and serve Johnson County — including Overland Park, Leawood, Shawnee, Lenexa, and Prairie Village, plus the surrounding communities.",
  },
  {
    q: "What lawn and landscape services do you offer?",
    a: "We offer mowing (cutting, edging, blowing, and weeding), landscape maintenance (mulching, trimming, and planting shrubs), bed detailing to keep your beds weed-free and plants healthy, and turf applications including fertilizer and weed control.",
  },
  {
    q: "Are you insured?",
    a: "Yes. B&S Services KC is fully insured. Your property is protected when our crews are on the job.",
  },
  {
    q: "How much does lawn care cost?",
    a: "Pricing depends on the size of your property, the services you need, and how often we visit. We provide free, no-pressure written estimates — just reach out and tell us about your yard.",
  },
  {
    q: "Do you offer discounts for returning customers?",
    a: "Yes. Returning customers and friends of past customers get 10% off their next service. Ask us how to lock in your discount.",
  },
  {
    q: "How often do you visit for bed detailing?",
    a: "Bed detailing is available on a recurring schedule — monthly or every two weeks — to keep your landscaping beds clean of weeds and your plants in great condition.",
  },
  {
    q: "What hours are you available?",
    a: "We're available 24/7. Reach out any time and we'll get back to you to schedule your service.",
  },
  {
    q: "Do you handle both residential and commercial properties?",
    a: "Absolutely. We care for single-family homes, townhomes, HOAs, and commercial grounds throughout Johnson County with the same reliable, detail-focused service.",
  },
];
